<script setup lang="ts">
  import type { GroundInvestigationPoint, Properties, Geometry } from '@/stores/type/giPoint.type'
  import type { SectionLine } from '@/stores/type/sectionLine.type'
  import { getGIDipslayName } from '@/utils/giPoint'
  import type { ComputedRef, PropType } from 'vue'

  const emit = defineEmits(['update:selectedItems', 'toggleSelect'])
  const props = defineProps({
    item: { type: Object as PropType<GroundInvestigationPoint>, required: true },
    sectionLine: { type: Object as PropType<SectionLine>, default: () => ({}) },
    selectedItems: {
      type: Array as PropType<number[]>,
      default: () => []
    },
    showSelect: { type: Boolean, default: false }
  })
  const properties: ComputedRef<Properties> = computed(() => props.item.properties)
  const geometry: ComputedRef<Geometry> = computed(() => props.item.geometry)
  const giType = computed(() => {
    return getGIDipslayName(props.item)
  })
  const isSelected = computed(() => props.selectedItems.includes(props.item.id))

  const coordinateToFixed = (coordinate: number) => {
    if (!coordinate) return ''
    return coordinate.toFixed(3)
  }
</script>
<template>
  <tr>
    <td v-if="props.showSelect">
      <v-checkbox
        color="primary"
        density="compact"
        v-model="isSelected"
        hide-details
        class="ml-n1"
        @click.stop="emit('update:selectedItems', item.id)"
      ></v-checkbox>
    </td>

    <td class="text-primary two-line-cell">
      <div class="two-line-cell">{{ properties.location_id }}</div>
    </td>
    <td>{{ properties.survey_company }}</td>
    <td>{{ properties.survey_datestring }}</td>
    <td>{{ giType }}</td>
    <td>{{ properties.end_depth }}</td>
    <td>{{ coordinateToFixed(geometry?.coordinates[2]) }}</td>
  </tr>
</template>

<style scoped>
  .two-line-cell {
    min-height: calc(2 * 1em * 1.25);
    align-content: center;
  }
</style>
